export default __webpack_public_path__ + "static/media/page8.3f66d633.png";